module.exports = __webpack_public_path__ + "img/type-italic.44da22e7.svg";